
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'isLogged',
      'CurrentUser',
      'NumberOfAgents',
      'ActiveAgents',
      'SmartAgentActive',
      'ShowSmartAgentGuidAgentsPage',
      'displayOtp', /*return user phone number , else returns Bool false* */
      'ShowSmartAgentGuidMyBoard',
      'NoJobBasket'

    ])
  }
};
